import { render, staticRenderFns } from "./Adversus.vue?vue&type=template&id=8a27a240&scoped=true&"
import script from "./Adversus.vue?vue&type=script&lang=js&"
export * from "./Adversus.vue?vue&type=script&lang=js&"
import style0 from "./Adversus.vue?vue&type=style&index=0&id=8a27a240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a27a240",
  null
  
)

export default component.exports